var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDessert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.212 10.0158V22.641C27.212 23.0912 26.8473 23.4555 26.3975 23.4555H2.7762C2.32637 23.4555 1.96167 23.0912 1.96167 22.641V10.0158C1.96167 9.56641 2.32637 9.20129 2.7762 9.20129L16.6216 6.98639",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5542 5.96408C25.6084 6.17186 27.212 7.90713 27.212 10.0158",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96168 9.65928L2.36894 14.903C3.49368 14.903 4.40526 13.9914 4.40526 12.8671C4.40526 11.7423 5.31683 10.8303 6.44157 10.8303C7.56631 10.8303 8.47789 11.7423 8.47789 12.8671C8.47789 13.9914 9.38947 14.903 10.5142 14.903C11.6389 14.903 12.5505 13.9914 12.5505 12.8671C12.5505 11.7423 13.4621 10.8303 14.5868 10.8303C15.7116 10.8303 16.6232 11.7423 16.6232 12.8671C16.6232 13.9914 17.5347 14.903 18.6595 14.903C19.7842 14.903 20.6958 13.9914 20.6958 12.8671C20.6958 11.7423 21.6074 10.8303 22.7321 10.8303C23.8568 10.8303 24.7684 11.7423 24.7684 12.8671C24.7684 13.9914 25.68 14.903 26.8047 14.903L26.413 6.48966",
    fill: "#FCC436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96167 18.8845H27.212",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0849 9.33812C21.9598 9.33812 23.4796 7.81825 23.4796 5.9434C23.4796 4.06854 21.9598 2.54867 20.0849 2.54867C18.21 2.54867 16.6902 4.06854 16.6902 5.9434C16.6902 7.81825 18.21 9.33812 20.0849 9.33812Z",
    fill: "white",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0848 5.12867C20.0848 2.87939 21.908 1.05603 24.1575 1.05603",
    stroke: "#FCC436",
    strokeWidth: 1.81121,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDessert);
export default __webpack_public_path__ + "static/media/dessert.c020feb615a65f004f9f7cfbac6b8c62.svg";
export { ForwardRef as ReactComponent };